<template>
  <div class="section" id="action">
    <div class="action_wrap">
      <div class="title">Ready to learn?</div>
      <div class="options">
        <button>Sign up</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {},
  },
};
</script>
<style>
.section#action {
  padding: 1rem 0rem;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1b212c;
}

.section#action .action_wrap .title {
  font-size: 3rem;
  font-family: "Volkhov", serif;
  font-weight: 400;
  margin-bottom: 4rem;
  color: #fff;
}
.section#action .options {
  width: 100%;
  text-align: center;
}
.section#action .options button {
  padding: 8px 30px;
  border-radius: 5px;
  background-color: #4571c9;
  color: #fff;
  border: none;
  width: 70%;
  box-shadow: none;
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  font-weight: 500;
  transition: background-color 0.2s;
}
.section#action .options button:hover {
  background-color: #3a66bd;
  transition: background-color 0.2s;
}
</style>